import * as React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import { Flex, Box } from '@rebass/grid/emotion'

import Header, { TopBar } from '../components/Header'
import { Global, css } from '@emotion/core'
import { LocaleContext } from '../i18n'
import Kokoro from '../assets/kokoro.svg'
import { StickyContainer, Sticky } from 'react-sticky'
import { colors } from '../styles/variables'
import PageContext from '../components/pageContext'

import normalize from '../styles/normalize'
import 'modern-normalize'
import '../styles/normalize'
import SEO from '../components/SEO'

type StaticQueryProps = {
  site: {
    siteMetadata: {
      title: string
      description: string
      keywords: string[]
    }
  }
}

// tODO
// const pageTitle = locale ? translations[locale][`${localeKey}.title`] : '';

const IndexLayout: React.SFC<{ pageContext: PageContext }> = ({ children, pageContext }) => (
  <StaticQuery
    query={graphql`
      query IndexLayoutQuery {
        site {
          siteMetadata {
            title
            description
          }
        }
      }
    `}
    render={(data: StaticQueryProps) => (
      <PageContext.Provider value={pageContext}>
        <PageContext.Consumer>{({ path, locale, translation }) =>
          <LocaleContext.Provider value={{ locale, t: (val) => translation[val] || `missing ${val}` }}>
            <Global styles={() => css(normalize)} />
            <SEO lang={locale} />
            <Flex
              flexDirection="column"
              css={css`min-height: 100vh;`}
            >
              <Flex
                flexDirection="column"
                flex="1"
              >
                <StickyContainer>
                  <Sticky>{({ style }) =>
                    <div style={{ ...style, zIndex: 1, background: '#FFF' }}>
                      <TopBar />
                      <Header title={data.site.siteMetadata.title} />
                    </div>}
                  </Sticky>
                  {children}
                </StickyContainer>
              </Flex>
              <Box m="auto" p={2} css={css`text-align: center;`}>
                <Kokoro
                  css={css`
              width: 25px;
              fill: ${colors.link};
            `} />
              </Box>
            </Flex>
          </LocaleContext.Provider>
        }</PageContext.Consumer>
      </PageContext.Provider>
    )}
  />
)

export default IndexLayout
